// landing_page/src/components/seo.js
import * as React from "react";
import { Helmet } from "react-helmet";
import { useIntl } from "react-intl";
import { useStaticQuery, graphql } from "gatsby";
import { useLocation } from "@reach/router";

function Seo({ description, title }) {
  const intl = useIntl();

  // pobieramy siteUrl z siteMetadata
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);

  // obecna ścieżka
  const location = useLocation();
  const canonicalUrl = `${site.siteMetadata.siteUrl}${location.pathname}`;

  const metaDescription =
    description || intl.formatMessage({ id: "seoDescription" });
  const defaultTitle = intl.formatMessage({ id: "seoTitle" });
  const fullTitle = defaultTitle ? `${title} | ${defaultTitle}` : title;
  const twitterCreator = intl.formatMessage({ id: "author" });
  const metaKeywords = intl.formatMessage({ id: "seoKeywords" });

  return (
    <Helmet>
      <title>{fullTitle}</title>

      {/* kanoniczny URL */}
      <link rel="canonical" href={canonicalUrl} />

      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={twitterCreator} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />

      {/* Google Tag (gtag.js) */}
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-NP2NS35P59"
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-NP2NS35P59');
          `,
        }}
      />
    </Helmet>
  );
}

// Gatsby Head API
export const Head = (props) => <Seo {...props} />;

export default Seo;
